export function compareNumbers(a, b) {
  return a - b;
}
